import { ALL_LNGS_NAMESPACES, LNGS_NAMESPACE_LOGICAL_DEVICE, LNGS_NAMESPACE_TASKS } from '@ingenico/util-i18n-config';
import { toString } from 'lodash-es';
import { useTranslation } from 'react-i18next';
import type { DeviceResourceDiagnosticsTestResult } from '../../domain/models/DeviceDiagnosticsDetails.model';

export function useDeviceDiagnosticDetailsDrawer(testResultDetails?: DeviceResourceDiagnosticsTestResult) {
  const resultCode = toString(testResultDetails?.resultCode);

  const { t } = useTranslation([
    ...Object.values(LNGS_NAMESPACE_TASKS),
    ALL_LNGS_NAMESPACES.COMMON,
    ALL_LNGS_NAMESPACES.LOGICAL_DEVICE,
    LNGS_NAMESPACE_LOGICAL_DEVICE.ERROR_DIAGNOSTICS,
  ]);

  const result = resultCode
    ? toString(
        t([`resultCodes.${resultCode}.result`, 'Not available'], {
          ns: LNGS_NAMESPACE_LOGICAL_DEVICE.ERROR_DIAGNOSTICS,
        }),
      )
    : '';
  const details = resultCode
    ? toString(t([`resultCodes.${resultCode}.details`, ''], { ns: LNGS_NAMESPACE_LOGICAL_DEVICE.ERROR_DIAGNOSTICS }))
    : '';
  const fix = resultCode
    ? toString(t([`resultCodes.${resultCode}.fix`, ''], { ns: LNGS_NAMESPACE_LOGICAL_DEVICE.ERROR_DIAGNOSTICS }))
    : '';
  const parser = new DOMParser();
  const doc = parser.parseFromString(fix, 'text/html');

  const rawModule = toString(testResultDetails?.module ?? '');
  const translatedModule = rawModule
    ? toString(
        t(`modules.${rawModule}`, {
          ns: ALL_LNGS_NAMESPACES.ERROR_DIAGNOSTICS,
        }),
      )
    : '';

  return {
    resultCode,
    result,
    details,
    fix,
    doc,
    translatedModule,
    t,
  };
}
